import { Fragment, createRef } from 'react';
import trackInMatomoAndGA from 'Shared/Analytics/CombinedGAMatomo';

const withLanguageForm = (LanguagesContainer: any) => {
   return (props: any) => {
      const languageForm = createRef<HTMLFormElement>();
      const languageInput = createRef<HTMLInputElement>();

      const submitForm = () => {
         languageForm.current.submit();
      };

      const onClickLanguage = (clickedLangId: any) => {
         languageInput.current.value = clickedLangId;
         if (!App.canIBypassGAEventFiringOnMobile && App.lang != clickedLangId) {
            trackInMatomoAndGA({
               eventCategory: 'Language',
               eventAction: `Language Switcher - ${App.lang} - ${clickedLangId}`,
            });
         }
         submitForm();
      };

      return (
         <Fragment>
            <LanguagesContainer {...props} onClickLanguage={onClickLanguage} />
            <form ref={languageForm} method="POST" action={props.translationPreferencesUrl}>
               <input ref={languageInput} type="hidden" name="langid" value={''} />
            </form>
         </Fragment>
      );
   };
};

export default withLanguageForm;
